import React, { useState, useEffect } from 'react';
import { FaBars } from 'react-icons/fa';
import './dashboard.css';
import Side from './Side/side.js';
import ImageGenerator from './Center/default/main.js';
import { getArtGenFormats, getProfile } from '../../api/api';

function Dashboard() {
    const [isSidebarActive, setSidebarActive] = useState(true);
    const [artFormats, setArtFormats] = useState(null);
    const [selectedFormat, setSelectedFormat] = useState(null);
    const [isLoading, setIsLoading] = useState(true);
    const [error, setError] = useState(null);
    const [userProfile, setUserProfile] = useState(null);

    const updateProfileData = async () => {
        try {
            const profileResponse = await getProfile();
            
            // Update both state and localStorage
            setUserProfile(profileResponse.data);
            localStorage.setItem('userProfile', JSON.stringify(profileResponse.data));
            localStorage.setItem('userId', profileResponse.data.userId);
            
            // Dispatch custom event for same-tab updates
            window.dispatchEvent(new Event('storage-local'));
        } catch (err) {
            console.error('Error updating profile:', err);
        }
    };

    useEffect(() => {
        const fetchData = async () => {
            try {
                // Fetch art formats
                const artFormatsResponse = await getArtGenFormats();
                setArtFormats(artFormatsResponse.data.data);
                setSelectedFormat(Object.keys(artFormatsResponse.data.data)[0]);

                // Fetch initial profile data
                await updateProfileData();
                
                setIsLoading(false);
            } catch (err) {
                console.error('Error fetching data:', err);
                setError('Failed to load required data. Please try again later.');
                setIsLoading(false);
            }
        };

        fetchData();
    }, []);

    const toggleSidebar = () => {
        setSidebarActive(!isSidebarActive);
    };

    return (
        <div className="dashboard-container">
            <button 
                className="sidebar-toggle" 
                onClick={toggleSidebar}
                aria-label="Toggle Sidebar"
            >
                <FaBars />
            </button>
            <div className="dashboard-main">
                <Side 
                    isSidebarActive={isSidebarActive} 
                    artFormats={artFormats}
                    selectedFormat={selectedFormat}
                    onFormatSelect={setSelectedFormat}
                    isLoading={isLoading}
                    userProfile={userProfile}
                />
                <div className={`dashboard-content ${isSidebarActive ? 'sidebar-active' : ''}`}>
                    {isLoading ? (
                        <div className="loading-message">Loading art formats...</div>
                    ) : error ? (
                        <div className="error-message">{error}</div>
                    ) : artFormats && selectedFormat ? (
                        <ImageGenerator 
                            selectedFormat={selectedFormat}
                            artFormats={artFormats}
                            userProfile={userProfile}
                            onProfileUpdate={updateProfileData}
                        />
                    ) : null}
                </div>
            </div>
        </div>
    );
}

export default Dashboard;
